export default [
    {
        name: "Picklist_Yes",
        value: "yes"
    },
    {
        name: "Picklist_No",
        value: "no"
    }
]